import PropTypes from "prop-types";
import React from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    title(props) {
        const { alternateColor } = props;
        return {
            color: alternateColor
                ? theme.palette.common.white
                : theme.palette.common.black,
            marginBottom: theme.spacing(4)
        };
    }
}));

const Part = ({ title, ...props }) => {
    const classes = useStyles(props);
    return (
        <>
            <div className={classes.title}>
                <Typography variant="h4">{title}</Typography>
            </div>
            <div>{props.children}</div>
        </>
    );
};

Part.propTypes = {
    alternateColor: PropTypes.bool,
    title: PropTypes.node.isRequired
};

export default Part;
